export const studentCourses = {
	type: 'array',
	items: {
		type: 'object',
		required: [
			'id',
			'startDate'
		],
		properties: {
			id: {
				type: 'integer',
			},
			startDate: {
				type: 'string',
				format: 'date-time'
			},
			exams: {
				$ref: '/student-exams'
			}
		}
	}
};